import loadView from "../../common/loadView";
import simpleLayout from "@/layouts/single-card";

export default [
	{
		path: "/registration/choose-type/:taxiDepotName",
		name: "registration-choose-type",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "YandexRegistration",
		},
		component: loadView("registration/choose-type"),
	},
	{
		path: "/registration/driver/sms-send",
		name: "registration-driver-sms-send",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "YandexRegistration",
		},
		component: loadView("registration/driver/sms-send"),
	},
	{
		path: "/registration/confirm-sms",
		name: "registration-confirm-sms",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "",
		},
		component: loadView("registration/confirm-sms"),
	},
	{
		path: "/registration/driver",
		name: "registration-driver",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "YandexRegistration",
		},
		component: loadView("registration/driver/driver-form"),
	},
	{
		path: "/registration/driver/car",
		name: "registration-driver-car",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "YandexRegistration",
		},
		component: loadView("registration/driver/car-form"),
	},
	{
		path: "/registration/finish",
		name: "registration-finish",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			title: "YandexRegistration",
		},
		component: loadView("registration/finish"),
	},

	{
		path: "/registration/courier/walk/send-sms",
		name: "registration-courier-walk-send-sms",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			type: "courier-walk",
			title: "YandexRegistration",
		},
		component: loadView("registration/courier/courier-walk-send-sms"),
	},

	{
		path: "/registration/courier/walk/form",
		name: "registration-courier-walk-form",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			disabledTypes: true,
			type: "courier-walk",
			title: "YandexRegistration",
		},
		component: loadView("registration/courier/courier-walk-form"),
	},

	{
		path: "/registration/courier/moto/send-sms",
		name: "registration-courier-moto-send-sms",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			type: "courier-moto",
			title: "YandexRegistration",
		},
		component: loadView("registration/courier/courier-moto-send-sms"),
	},

	{
		path: "/registration/courier/moto/form",
		name: "registration-courier-moto-form",
		meta: {
			requiresAuth: false,
			layout: simpleLayout,
			disabledTypes: true,
			type: "courier-moto",
			title: "YandexRegistration",
		},
		component: loadView("registration/courier/courier-moto-form"),
	},
];
